const holder = {
  closeDateSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false });
      document.removeEventListener('mousedown', holder.closeDateSelector);
    }
  }
};


export default {
  'InspectionExport.RelativeWrapper.Selector': ({ isOpen, containerRef }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;
    internalStateSetter({ isOpen: !isOpen });
    if (isOpen) {
      document.removeEventListener('mousedown', holder.closeDateSelector);
    } else {
      document.addEventListener('mousedown', holder.closeDateSelector);
    }
  },
  'InspectionExport.RelativeWrapper.DropdownWrapper.Wrapper.Pdf': ({ showPdf }, _, internalStateSetter) => {
    internalStateSetter({ showPdf: !showPdf })
  },
  'InspectionExport.RelativeWrapper.DropdownWrapper.Wrapper.Images': ({ }, outlet) => {
    outlet({ action: 'allImages' })
  },
  'InspectionExport.RelativeWrapper.DropdownWrapper.PdfDropdownWrapper.Wrapper.Comments': ({ includeComments }, _, internalStateSetter) => {
    internalStateSetter({ includeComments: !includeComments });
  },
  'InspectionExport.RelativeWrapper.DropdownWrapper.PdfDropdownWrapper.Wrapper.Cost': ({ includeCost }, _, internalStateSetter) => {
    internalStateSetter({ includeCost: !includeCost });
  },
  'InspectionExport.RelativeWrapper.DropdownWrapper.PdfDropdownWrapper.Wrapper.Images': ({ includeImages }, _, internalStateSetter) => {
    internalStateSetter({ includeImages: !includeImages });
  },
  'InspectionExport.RelativeWrapper.DropdownWrapper.PdfDropdownWrapper.Wrapper.Button': ({ includeComments, includeImages, includeCost }, outlet) => {
    outlet({ action: 'exportPdf', includeComments, includeImages, includeCost })
  },
}
